export default {
  Growth: {
    rentalTitle: "Rental Market",
    rentalDesc: "Rent licenses from other holders - or list yours and earn rent.",
    listingCount: "Listed",
    avgDailyRent: "Avg rent/day",
    deals7d: "Deals (7d)",
    totalRent: "Total rent",
    termLabel: "Term",
    dailyRent: "Per day",
    annualized: "Annualized",
    rentNow: "Rent now",
    sortDaily: "By rent/day",
    sortTerm: "By term",
    sortPrice: "By price",
    sortNewest: "Newest",

    leaderboard: "Leaderboard",
    leaderboardDesc: "Traders ranked by real, settled on-chain results.",
    winRate: "Win rate",
    bets: "Bets",
    volume: "Volume",
    record: "{w}W · {l}L",
    winLose: "W / L",
    loadMore: "Load more",
    empty: "No data yet",
    trader: "Trader",
    rankLabel: "Rank",
    selling: "Listed now",
    recent: "Recent results",
    none: "None",
    follow: "Copy",
    modeSale: "Sale",
    modeRental: "Rental",
    day: "d",
    periodAll: "All",
    period90: "90D",
    period30: "30D",
    period7: "7D",
    sortRoi: "By ROI",
    sortProfit: "By P&L",
    sortWinRate: "By win rate",
    sortVolume: "By volume",
    sortBets: "By bets",
    referralCenter: "Referral Center",
    referralRewards: "Referral Rewards",
    referralRewardsDesc: "Invite friends, share the rewards, and track VIP pools",
    myMode: "My mode",
    modeTeam: "Team",
    modeAgent: "Agent",
    l1Rate: "L1 rate",
    l2Rate: "L2 rate",
    myUpline: "My upline",
    uplineNone: "None",
    myVip: "VIP level",
    vipNotEnabled: "VIP pools are not enabled",
    vipNext: "Next level",
    vipDirect: "Direct",
    vipAsset: "Personal asset",
    vipTeamQualified: "Qualified team",
    vipPools: "Eligible pools",
    tabTeam: "Team",
    teamLevel: "Level",
    teamMembers: "Members",
    tabCommission: "Commissions",
    commLevel: "Level",
    commRate: "Rate",
    commAmount: "Amount",
    statusPending: "Pending",
    statusSettled: "Settled",
    channelOnChain: "On-chain",
    channelPlatform: "Platform",
    communityGroup: "Community & more",
    referralDesc: "Invite friends, grow the community, and earn rebates from their activity.",
    connectFirst: "Connect your wallet to open your referral center",
    directInvites: "Direct invites",
    totalDownline: "Total downline",
    earned: "Total rebates",
    pendingClaim: "Pending claim",
    myReferrer: "Referred by",
    inviteLink: "Your invite link",
    copy: "Copy",
    copied: "Copied!",
    linkHint: "Friends who open this link will be counted as your invites once they bind on-chain.",
    tabInvitees: "My invitees",
    tabRewards: "Rebate history",
    tabTop: "Top referrers",
    invitesCol: "Invites",
    typeInvite: "Invite",
    typeReward: "Reward",
    typeWithdraw: "Withdraw",
    bindTitle: "Bind your referrer",
    bindDesc: "Binding is stored on the server against your wallet address, so it stays with you on any device.",
    bindPlaceholder: "Enter the referrer address (0x...)",
    bindButton: "Sign & bind",
    bindFromLink: "From invite link",
    bindLocked: "Your referrer can only be set once.",
    bindSuccess: "Referrer bound",
    bindFailed: "Binding failed",
    bindSelf: "You cannot bind yourself",
    bindCancelled: "Signature cancelled",
  },
  progress: "Progress",
  timeLeft: "{t} left",
  ended: "Ended",
  fundTitle: "Funds",
  fundDesc: "Contract and wallet balances for each supported token",
  token: "Token",
  contractBalance: "Contract Balance",
  lockedAmount: "Locked",
  unlockTime: "Unlock in",
  depositToContract: "Deposit to Contract",
  withdrawToWallet: "Withdraw to Wallet",
  available: "Available",
  max: "Max",
  withdraw: "Withdraw",
  deposit: "Deposit",
  approve: "Approve",
  withdrawTip: "Withdrawals stay locked for a short period before the funds reach your wallet.",
  connectWallet: "Connect Wallet",
  // 测试币水龙头（Claim）
  faucetEntry: "Claim test tokens",
  faucetTitle: "Claim test tokens",
  faucetDesc: "Free test tokens are credited straight to your contract balance — no gas, no approval, ready to trade.",
  faucetClaim: "Claim now",
  faucetClaimed: "Claimed. Next claim in {t}",
  faucetClaimedBtn: "Next claim in {t}",
  faucetReady: "You can claim once every {h} hours.",
  faucetUnavailable: "Test tokens are not available on this network",
  faucetSuccess: "Test tokens credited to your contract balance",
  faucetFailed: "Claim failed, please retry",
  faucetTip: "Test tokens are for testing only and carry no value.",
  faucetTipInContract:
    "Test tokens are credited to your contract balance, not your wallet — you can trade right away, and a 0 wallet balance is expected.",
  fundLoading: "Loading balances…",
  // v2.1.0 多链
  selectChain: "Select network",
  chainOnlyOneHint: "Only one network is configured in this build. More networks appear here once they are configured and deployed.",
  chainSwitchFailed: "Network switch was cancelled",
  fundBalanceHint: "Cash + funds in open positions + locked withdrawals",
  fundCashHint: "Idle balance in the contract, ready to trade",
  // 站内转账
  transferToUser: "Transfer to another user",
  transferTitle: "Transfer",
  transferTo: "Recipient wallet address",
  transferAddressPlaceholder: "0x...",
  transferAmount: "Amount",
  transferSubmit: "Sign & transfer",
  transferTip: "Internal transfer: tokens move inside the platform ledger, nothing is sent on-chain and neither side pays gas.",
  transferSuccess: "Transfer completed",
  transferFailed: "Transfer failed",
  transferCancelled: "Signature cancelled",
  transferSelf: "You cannot transfer to yourself",
  transferInsufficient: "Insufficient available balance",
  transferInvalidAddress: "Invalid recipient address",
  // v2.5.0 资金风控：后台紧急开关
  riskWithdrawPaused: "Withdrawals are temporarily paused. Please try again later.",
  riskTransferPaused: "Internal transfers are temporarily paused.",
  riskTradePaused: "Trading is temporarily paused.",
  // Vault（合约）侧充值/提现的前置条件提示
  vaultTokenNotAllowed: "This token is not enabled on the vault yet. Please contact the team.",
  vaultNotEnoughParticipation: "Withdrawal requires a minimum number of participations. Please join a market first.",
  vaultWithdrawDisabled: "Withdrawals are temporarily disabled by the platform.",
  vaultSignatureExpired: "The withdrawal authorization expired. Please try again.",
  withdrawPending: "You already have a withdrawal in progress. Please wait for it to finish.",
  withdrawPoolInsufficient: "The vault does not have enough liquidity right now. Please try again later.",
  insufficientBalance: "Insufficient balance",
  // v1.9.22：钱包 RPC 限流（429）
  rpcRateLimited: "Network is busy (RPC 429)",
  rpcRateLimitedDesc: "Your wallet's RPC node is rate-limiting requests. We switched to a backup node — please retry. On-chain funds were not moved.",
  pendingSignatureTip: "Your withdrawal authorization is still valid for a few minutes. Retry sending reuses it, so your balance will not be locked again.",
  retrySend: "Retry sending",
  withdrawUnlocked: "Your withdrawal was not submitted on-chain. The locked amount has been unlocked.",
  withdrawUnlockFailed: "Could not unlock the amount just now. It will be released automatically in a few minutes.",

  // 可用资金（所有投资环节都必须显示，避免用户不知道最多能投多少）
  availableInContract: "Available in contract",
  max: "Max",
  shares: "Shares",
  positionValue: "Value",
  potentialPayout: "Potential payout",

  // 平台动态（Activity）
  activity: "Activity",
  activityTitle: "Activity",
  activitySubtitle: "Every participation across all markets, refreshed every 3 seconds.",
  activityLive: "Live",
  activityAllBoards: "All",
  activityFilteredBy: "Filtered by wallet",
  activityClearFilter: "Clear",
  activityColMarket: "Market",
  activityColUser: "Trader",
  activityColOption: "Option",
  activityColAmount: "Amount",
  activityColTime: "Time",
  activityEmpty: "No activity yet",
  activityEmptyHint: "Participations will show up here as soon as someone places an order.",
  activityTotal: "{n} participations",
  activityLoadMore: "Load more",
  activityEnd: "You are all caught up",
  activityJustNow: "just now",
  activitySecondsAgo: "{n}s ago",
  activityMinutesAgo: "{n}m ago",
  activityHoursAgo: "{n}h ago",
  activityDaysAgo: "{n}d ago",
    walletBalance: "Wallet Balance",
    collect:"Collect",
    approve:"Approve",
    ticket: "License",
    category: "Category",
    sortBy: "Sort By",
    issue: "Issue",
    confirm: "Confirm",
    detail: "Detail",
    stakingType: "Collateral",
    stakingTypeInfo: "To prevent issuer from confirming result viciously,please stake tokens or current NFT.",
    subscriptionAmount: "Subscription Amount",
    subscription: "Subscription",
    subscribe:"Buy",
    max: "Max",
    marketClosed: "Market Closed",
    add: "Add",
    verifiedNFT: "Check Verified License",
    select: "Select",
    selected: "Selected",
    moreNFT: "Get more License",
    forecastEvent: "Event",
    subscribeEndDate: "Last Trading Time",
    specifyLastTradingDate: "Specify Last Trading Time",
    specifyExpiryDate: "Specify Expiry Time",
    endDate: "End Time",
    validityPeriod: "Expiration Time",
    marketEndDate: "Expiration Time",
    liquidityMin:"Liquidity Min",
    premiumMin:"Premium Min",
    paymentCurrency: "Payment Currency",
    defaultOdds: "Default Leverage",
    setDefaultOdds: "Set Leverage",
    minInvestAmout: "Set The Minimum Investment Amount",
    depositMargin: "Add Liquidity",
    totalPayment: "Total Payment",
    rewards: "Rewards",
    rewardRate: "Reward Rate",
    release: "Release",
    fee: "Fee",
    marginFeeRate: "Fee Rate",
    cdsInfoOne: "When issue a prediction product, you have to stake the margin, set the default odds and the minimum investment amount.",
    cdsInfoTwo: "Unparticipating margin can be withdrawn at any time.",
    cdsInfoThree: "If more than 1 of the users choose to appeal the judgment result, the community governance mechanism will be initiated to determine whether the prediction event has occurred.",
    deposited: "Invested",
    issued: "Issued",
    deposit: "Deposit",
    depositedCDS: "invested products",
    totalProfit: "Total Profit",
    allOrDeposited: "Total/Deposited",
    rewardsOrProfit: "Rewards/Profit",
    estimatedInvested:"Estimated/Invested",
    profit: "Profit",
    yesterdayProfit: "Profit Yesterday",
    status: "Status",
    eventConfirming: "Event confirming",
    appeal: "Appeal",
    appealing: "Appealing",
    appealFailed: "Appeal Failed",
    occured: "Occured",
    notOccured: "Not Occured",
    governanceMechanism: "Initiate governance mechanism when the number of appeal exceeds one person.",
    appealLimit: "The number of appeal is not more than one person.",
    waitResult: "Waiting For Appeal Result",
    frozenMargin: "Frozen Margin",
    marginBalance: "Margin balance",
    balance: "Balance",
    cash: 'Cash',
    createNew: 'Create New',
    withdraw: "Withdraw",
    endTime: "Countdown To End",
    guaranteeing: "InProgress",
    guaranteeingEvent:"Prediction in progress",
    confirmsEventAdvance:"Event confirms occured in advance.",
    waitConfirmation:"Event is waiting for confirmation.",
    triggerEvent: "Event is confirmed to be occured.",
    notTriggerEvent: "Event  does not occur.",
    defaultChallenging:"Event occured, and is on challenging.",
    notDefaultChallenging:"Event did not occur, and is on challenging.",
    defaultChallengeFailed:"Event occured,and challenge failed.",
    notDefaultChallengeFailed:"Event did not occur,and challenge failed.",
    defaultWaitingResult:"Event occured,and is waiting for governance mechanism results.",
    notDefaultWaitingResult:"Event did not occur,and is waiting for governance mechanism results.",
    defaultGovernanceMechanism:"Governance mechanism confirms event occured.",
    notDefaultGovernanceMechanism:"Governance mechanism confirms that event does not occur.",
    cancel: "Cancel",
    defaultAhead:"Occured Ahead",
    occur: "Occured",
    notOccur: "Not occured",
    stakingToChallenge:"Staking to Challenge",
    challenged:"Challenged",
    checking: "Checking",
    fail: "Fail",


    appealInfoOne: 'If you think that the judgment of the current prediction event deviates from the facts, you can "Challenge" and start the governance mechanism to finally determine the current prediction result.',
    check: "Check",
    contentIllegal: "Prediction event involves content illegal, please edit the content again to issue",
    subscribed: "Invested products",
    receivingCompensation: "Pending",
    received: "Total Payoff",
    receive: "Receive",
    compensationAmount: "Occured compensation amount",
    liquidity: "Liquidity",
    injectLiquidity: "Inject Liquidity",
    uRLContent:"URL/Content",
    resolutionSource:"Resolution Source",
    textareaInfo: "Please describe this event briefly.",
    language: 'Language',
    theme: "Theme",
    network: "Network",

    // 新增：补齐模板使用的顶层键，避免 vue-i18n 警告
    home: "Home",
    market: "Market",
    markets: "Markets",
    community: "Community",

    // 四个产品板块（PRD v1.1）：导航下拉 + 移动端页内 tab
    productType: "Board",
    // 板块名一律带 Markets 后缀：导航下拉里只写 "Classic" 对新用户毫无信息量
    typeClassic: "Classic Markets",
    typeDynamic: "Dynamic Markets",
    typeFixedOdds: "Fixed-Odds Markets",
    typePrice: "Price Markets",
    zoneAll: "All",
    zonePlatform: "Platform",
    zonePartner: "Partner Zone",
    // 可插拔模块状态（底座 + 业务模块）
    typePaused: "Paused",
    typePausedHint: "This board is paused: you can browse existing markets, but creating and joining are temporarily disabled.",
    // 标签要短（贴在板块名后面，移动端一行放不下长文案），故用 Upcoming
    typeOffline: "Upcoming",
    typeOfflineHint: "This board is not launched yet: it keeps its name in the nav as a placeholder, but you can't enter it until it is opened.",
    // Price 板块（链下）
    priceAutoIssued: "Auto-issued",
    priceIssueHint: "Price markets are issued automatically by the platform. Pick another board to create your own.",
    priceCurrent: "Current price",
    priceIssuePrice: "Open price",
    priceSettlePrice: "Settle price",
    pricePool: "Total pool",
    priceJoin: "Join this round",
    // v2.4.0 直投模式（direct）：钱包直接投入，合约内结算
    priceJoinDirect: "Join (pay from wallet)",
    priceDirectHint: "Direct mode: your wallet pays the market contract directly - no deposit, settlement happens on-chain. Minimum per bet:",
    priceClaim: "Claim",
    priceDirectMinAmount: "Minimum per bet is",
    priceDirectNoDeposit: "Direct mode has no custodial balance: deposit and withdrawal are unavailable, and winnings are paid straight to your wallet.",
    pricePositionsTitle: "Price Positions",
    priceOption: "Option",
    priceAmount: "Stake",
    pricePayout: "Payout",

    // ---- Portfolio 一级页签 + 资金/奖励中心（v1.2 §5/§6）----
    portfolioTabPositions: "Positions",
    portfolioTabFunds: "Funds",
    portfolioTabRewards: "Rewards",
    fundsAvailable: "Available",
    fundsLocked: "Locked",
    fundsOpenCost: "Open cost",
    fundsMarketValue: "Current value",
    fundsUnrealized: "Unrealized PnL",
    fundsRealized: "Realized PnL",
    fundsFeesPaid: "Total fees",
    fundsReferralIncome: "Referral income",
    fundsValuationNote: "Open positions are valued at LMSR price for Dynamic Markets and at cost for the other boards; unrealized PnL is not realized until settlement.",
    fundsActivity: "Activity",
    fundsSettlements: "Settlements",
    fundsAllActions: "All actions",
    fundsAllStatus: "All statuses",
    fundsAllSources: "All sources",
    fundsColTime: "Time",
    boardName: "Board",
    fundsColAction: "Action",
    fundsColPrincipal: "Principal",
    fundsColEntryFee: "Entry fee",
    fundsColExitFee: "Exit fee",
    fundsColSettleFee: "Settle fee",
    fundsColNetCash: "Net cash",
    fundsColRealized: "Realized",
    fundsColRefund: "Refund",
    actBuy: "Buy",
    actChallenge: "Challenge",
    actIssueIncome: "Issue income",
    actPayout: "Payout",
    actRefund: "Refund",
    actReferral: "Referral reward",
    actVipReward: "VIP reward",
    actFirstInvest: "First-invest bonus",
    actRiskCapital: "Risk capital",
    actMakerIncome: "Maker income",
    actFaucet: "Test token faucet",
    actTransferOut: "Transfer out",
    actTransferIn: "Transfer in",
    rewardTotal: "Total rewards",
    rewardPending: "Pending",
    rewardConfirmed: "Confirmed",
    rewardPaid: "Paid",
    rewardReversed: "Reversed",
    rewardClaimable: "Claimable",
    rewardNote: "Rewards from entry/exit fees, settlement income, platform net income and promotion budget. Reversed items keep the original record with a reversal entry - nothing is ever deleted.",
    rewardColSource: "Source",
    rewardColInvitee: "Invitee",
    rewardColLevel: "Level",
    rewardColRate: "Rate",
    rewardColAmount: "Amount",
    rewardColConfirmAt: "Confirm ETA",
    rewardStatusPending: "Pending",
    rewardStatusConfirmed: "Confirmed",
    rewardStatusPaid: "Paid",
    rewardStatusFrozen: "Frozen",
    rewardStatusReversed: "Reversed",
    rewardSrcEntryFee: "Entry fee share",
    rewardSrcExitFee: "Exit fee share",
    rewardSrcSettlement: "Settlement share",
    rewardSrcPlatformNet: "Platform net share",
    rewardSrcPromotion: "Promotion budget",
    typeEmptyTitle: "Coming soon",
    typeEmptyHint: "Switch back to Classic to explore live markets.",
    typeDescClassic: "Classic Markets are the original prediction format: everyone who picks the winning option shares the pool in proportion to what they put in.",
    typeDescDynamic: "Dynamic Markets let you trade outcome shares at AMM-driven prices - buy or sell any time before resolution, and the price always reflects the crowd's implied probability.",
    typeDescFixedOdds: "Fixed-Odds Markets put the issuer in the bookmaker's seat: they post the funds and set the odds, you bet against them at a payout locked before you commit.",
    typeDescPrice: "Price Markets settle automatically from a whitelisted price feed - pick a window (hourly, daily, weekly) and call up or down on BTC, ETH and more.",
    // Dynamic / Fixed-Odds 参与面板
    dynamicMarket: "Dynamic Market",
    fixedOddsMarket: "Fixed-Odds Market",
    shares: "Shares",
    capacityLeft: "Capacity left",
    capacity: "Capacity",
    bookmaker: "Bookmaker",
    marketPool: "Pool",
    totalStaked: "Total staked",
    riskCapital: "Risk capital",
    // ---- Fixed-Odds 用户注单提前退出（v1.9.16）----
    issuerNoExitHint: "As the product initiator you cannot withdraw your risk capital - it stays locked until settlement.",
    myFixedOddsBets: "My bets",
    earlyExitBtn: "Exit early",
    earlyExitTitle: "Early exit quote",
    exitProgress: "Product cycle progress",
    exitStake: "Stake",
    exitValuationDeduction: "Valuation deduction",
    exitServiceFeeBps: "platform service fee",
    exitGraceTag: "Grace window",
    exitGraceNote: "Within the grace window you only pay the platform service fee.",
    userExitDone: "Bet exited early",
    riskCapitalManage: "Risk capital",
    riskCapitalHint: "You are the counterparty on this market. Capital you inject is reserved against your outstanding payout obligations - releasing it early costs an exit fee and must still leave enough to cover what you owe.",
    riskCapitalInject: "Inject risk capital",
    riskCapitalInjectBtn: "Inject",
    riskCapitalInjected: "Risk capital injected",
    riskCapitalExit: "Withdraw early (exit fee applies)",
    riskCapitalExitBtn: "Withdraw",
    riskCapitalExited: "Risk capital withdrawn",
    exitFee: "Exit fee",
    exitMakerShare: "Your share as maker",
    exitPlatformShare: "Platform share",
    exitNet: "Net to you",
    exitSolvencyBlock: "Withdrawing this much would leave less risk capital than your outstanding obligations, so it is blocked.",
    estimatedCost: "Est. cost",
    estProceeds: "Est. proceeds",
    boardFee: "Fee",
    boardFeeFree: "Fee-free",
    boardFeeStage: "Time multiplier",
    boardFeeRate: "Rate",
    boardSlippageExceeded: "Price moved beyond your slippage limit. Please review the new quote and try again.",
    boardQuoteExpired: "Your quote expired. Please review the new price and try again.",
    boardQuoteStale: "The fee rule changed after your quote. Please review the new fee and try again.",
    potentialPayout: "Potential payout",
    bet: "Place bet",
    betOdds: "Odds",
    sortVolume: "Volume",
    sortNewest: "Newest",
    sortEndingSoon: "Ending soon",
    priceKlineEmpty: "No chart data yet",
    value: "Value",
    boardSettled: "Settled",
    noProducts: "No markets yet",
    noProductsDesc: "There are no markets live in this selection right now. Try another category or check back soon.",
    deposit: "Deposit",
    bridge: "Bridge",
    portfolio: "Portfolio",
    license: "License",
    myPositions: "My Positions",
    history: "History",
    inputSearchText: "Please enter search content",
    predictionProduct: "Prediction product",
    listYourToken: "List your token",
    description: "Description",
    setResultModalTitle: "Set Result:",
    cancelModalTitle: "Cancel",
    cancelIrreversible: "Cancellation is irreversible.",
    challengeModalTitle: "Challenge",
    challengeStakeIntro: "if there is deviation in fact, will be returned to you.",
    challengeStakeButton: "PRDS to Challenge",

    issuerResult: "Issuer Result",
    daoResult: "DAO Result",
    waitingGovernanceResult: "Event is waiting for governance mechanism results.",
    eventFinished: "Event is Finished.",
    recycleTicket: "Recycle ticket",
    eventCancelled: "Event has been cancelled.",
    challenge: "Challenge",
    share: "Share",
    USDT: "USDT",

        licenses: "Licenses",
        prediLicense: "Predi License",
        issuableQuantity: "Issuable quantity",
        disabled: "Disabled",
        battleImage: "Battle Image",
        upload: "Upload",
        showSample: "Show Sample",
        battleInformation: "Battle Information",
        baseToken: "Base Token",
        collateral: "Collateral",
        currentLicense: "Current License",
        predictionProject: "Prediction Project:",
        issueExpireIntro: "At the expiration time, those who have chosen the correct option will share tokens from the product pool based on their participation shares.",
        issueParticipateUntil: "Users can participate in this product until",
        issueConfirmAdvance: "The result can be confirmed in advance by issuer, if the event occurs before expiration time.",
        issueChallengeWithin7Days: "If the participants disagree with the result of event confirmed by issuer, they can \"Challenge\" it within 7 days of confirmation.",
        // ---- 详情页 Description：四大板块各自的机制模板（字段/玩法不同，不能共用一套文案）----
        descDynamicWhat: "This is a Dynamic Market: outcomes are traded as shares whose prices move with every buy and sell, exactly like Polymarket.",
        descDynamicPrice: "Each option shows a live price between 0 and 1 - that price is the market's implied probability of it winning. All option prices always add up to 1.",
        descDynamicLiquidity: "Prices are set by an automated market maker (LMSR). This market's liquidity parameter b is",
        descDynamicTrade: "You can buy or sell shares at any time before the market closes. Buying pushes an option's price up, selling pushes it down, and you can always exit a position early.",
        descDynamicSettle: "When the event resolves, every share of the winning option pays out 1 token. Shares of losing options become worthless.",
        descFixedWhat: "This is a Fixed-Odds Market: the issuer acts as the bookmaker, posting the funds on the other side of every bet, and you bet against them at odds locked before you commit.",
        descFixedBookmaker: "Because the issuer funds the opposite side, your payout is guaranteed by the capacity they posted - you know your exact return before you bet.",
        descFixedExample: "Example: an issuer posts 1,000,000 on \"no rate hike\" at 5x odds. If you bet 100 on \"rate hike\" and it happens, you receive 500 back. If it does not happen, your 100 goes to the issuer.",
        descFixedOdds: "Current odds on this market:",
        descFixedSettle: "At resolution, winning bets are paid stake x locked odds and losing stakes are forfeited to the issuer. Odds never change once a bet is placed.",
        descPriceWhat: "This is a Price Market: call the direction of a trading pair over a fixed window. There are only two outcomes - Up and Down.",
        descPriceBase: "The issue price recorded when this market opened is",
        descPriceSettle: "The settlement price is taken automatically from a whitelisted price feed at expiry: above the issue price means Up wins, otherwise Down wins. Winners share the pool in proportion to their stake.",
        issueAttention: "Attention: Predi is committed to fostering entertainment and social experiences. All forms of gambling-related activities are strictly prohibited on this platform.",
        eventSampleTitle: "Event",
        // 示例刻意覆盖多选项场景（竞选 / 联赛排名 / 选美 / 区间），不要再全用 yes/no
        issueSampleElection: "Who wins the next national presidential election?",
        issueSampleElectionOpts: "Alex Rivera / Jordan Blake / Sam Okafor / Mei Chen / Still undecided",
        issueSampleLeague: "Which club lifts the league title this season?",
        issueSampleLeagueOpts: "Arsenal / Liverpool / Man City / Chelsea / Tottenham / Newcastle",
        issueSamplePageant: "Who is crowned at this year's international pageant?",
        issueSamplePageantOpts: "Contestant A / Contestant B / Contestant C / Contestant D / Contestant E",
        issueSampleCrypto: "Where does BTC close at the end of the year?",
        issueSampleCryptoOpts: "Above 150k / 120k-150k / 90k-120k / Below 90k",
        issueSampleTech: "Which company ships the first mainstream AR glasses?",
        issueSampleTechOpts: "Apple / Meta / Samsung / Google / Someone else",
        issueSampleBinary: "Will the Fed cut rates at the next meeting?",
        issueSampleBinaryOpts: "Yes / No  (a plain yes/no question is fine with just two)",
        issueSampleMultiTip: "Options are free-form. Two for a yes/no question, as many as you like for elections, league tables or pageants. Default is two - just keep adding.",
        issuerResult: "Issuer Result",
        daoResult: "DAO Result",
        predictionToken: "Prediction Token",
        issuer: "Issuer",
        issuerProfit: "Issuer profit",

    donations: "Donations",

    // Issue.vue notifications (top-level)
    issueMsgPleaseSelectLicense: "Please select a License",
    issueMsgLicenseCannotBeStaked: "License cannot be staked",
    issueMsgNetworkNotConnected: "Network not connected",
    issueMsgEventEmpty: "Event is empty",
    issueMsgSelectLicense: "Select a License",
    issueMsgLastTradingDateEmpty: "Last trading time is empty",
    issueMsgExpirationDateEmpty: "Expiration time is empty",
    issueMsgOptionsEmpty: "Options cannot be empty",
    issueMsgOptionsLessThanTwo: "There cannot be less than two options",
    issueMsgOptionEmpty: "Option content cannot be empty",
    issueMsgOptionRepeated: "Option content cannot be repeated",
    issueMsgLiquidityInvalid: "Liquidity (b) must be greater than 0",
    issueMsgOddsInvalid: "Odds must be an integer between 2 and 1000",
    fixedOddsProductHint: "Odds are product-level: you set one integer multiplier at issue time (e.g. 100 = stake 1 to win 100). It applies to every option, regardless of Yes / No.",
    issueMsgCapacityInvalid: "Capacity must be 0 or greater",
    optionsMultiHint: "(2 by default, add more for multi-outcome events)",
    dynamicLiquidity: "Liquidity (b)",
    dynamicLiquidityHint: "Larger b means deeper book and less slippage per trade. 1000 suits stakes in the tens-to-hundreds range.",
    fixedOddsBookmakerHint: "You are the bookmaker here: the funds you post on each option are what your counterparties get paid from. Set the odds you are willing to honour and the maximum liability you can cover on each side.",
    issueMsgLastTradingDateGreaterThanToday: "Last trading time must be greater than today",
    issueMsgLastTradingDateGreaterThanExpirationDate: "Last trading time is greater than expiration time",
    issueMsgEventEndDateGreaterThanRentalEndDate: "Event end time {eventEndDate} is greater than rental end time {rentalEndDate}",
    issueMsgInsufficientBalance: "Insufficient balance",
    issueMsgTransactionFailed: "Transaction failed",
    issueMsgIssueSuccess: "Issue success",
    issueMsgTransactionCancelled: "Transaction cancelled",
    
    empowering: "Empowering Visionaries Predicting Futures",

    createYourOwnMarket: "Create Your Own Market",
    buyTicket: "Buy a Ticket",
    amount: "Amount",

    short:{
        confirmsEventAdvance:"Occured In Advance",
        waitConfirmation:"Waiting For Confirmation",
        defaultChallenging:"Occured-Challenging",
        notDefaultChallenging:"Not Occured-Challenging",
        defaultChallengeFailed:"Occured-Challenge Failed",
        notDefaultChallengeFailed:"Not Occured-Challenge Failed",
        defaultWaitingResult:"Occured-Governing",
        notDefaultWaitingResult:"Not Occured-Governing",
        defaultGovernanceMechanism:"Occured-Governance Confirmed",
        notDefaultGovernanceMechanism:"Not Occured-Governance Confirmed"
    },

    wallet: {
        openWallet: "Open Wallet",
        connectWallet: "Connect Wallet",
        connectingWallet: 'Connecting Wallet',
        connectYourWallet: "Connect your wallet",
        disconnect: "Disconnect",
        wrongNetwork: "Wrong Network"
    },
	
    // ---- v1.9.7 i18n 补漏：组件引用但语言包缺失的 key（纯追加）----
    go: "Go",
    noData: "No Data",
    linkCopied: "Link copied",
    linkCopyFailed: "Failed to copy link",
    pleaseSelectOption: "Please select an option",
    subscribeSuccess: "Subscribed successfully",
    transactionCancelled: "Transaction cancelled",
    transactionFailed: "Transaction failed",
    transactionSuccess: "Transaction successful",
    issueMsgLicenseError: "License error",
    issueMsgTicketError: "Ticket error",
    all: "All",
    bought: "Bought",
    boughtProducts: "Bought products",
    buy: "Buy",
    sell: "Sell",
    cancelled: "Cancelled",
    auditChecking: "Audit Checking",
    challengeCredit: "Challenge credit",
    challengeStatus: "Challenge status",
    comingSoon: "Coming Soon!",
    complaintCountdown: "Complaint Countdown",
    from: "From",
    to: "To",
    me: "Me",
    insufficientFunds: "Insufficient Funds",
    investedProducts: "Invested products",
    issuedProducts: "Issued products",
    loading: "Loading",
    newest: "Newest",
    options: "Options",
    pending: "Pending",
    positions: "Positions",
    price: "Price",
    return: "Return",
    setResult: "Set result",
    succeed: "Succeed",
    type: "Type",
    volume: "Volume",
    wait: "Wait",
    waitChallenge: "Event is waiting for challenge.",
    NFT: {
        getPrediLicense: "GET Predi License",
        referralRewards: "Referral Rewards",
        mintYourLicence: "Mint your licence",
        usageRights: "Usage Rights",
        issuePredictionProducts: "Issue Prediction Products",
        governance: "Governance",
        properties: "Properties",
        tradable: "Tradable",
        rentable: "Rentable",
        usable: "Usable",
        marketsToIssue: "Markets to Issue",
        times: "Times",
        availableTimes: "Available Times",
        ticketId: "Ticket ID",
        cancelRentHint: "This License is on renting, please cancel it and then you can sell it.",
        seeMore: "See More",
        sell: "Sell",
        rent: "Rent",
        share: "Share",
        USDT: "USDT",
        common: "Common",
        scarcity: "Scarcity",
        attributive: "Attributive",
        numbers: "Issue Number",
        issueTip:"Issue 10 prediction Markets/License",
        price: "Price",
        success: "Success",
        getNFT: "Get License successfully",
        issueCDS: "Issue Predi Markets",
        buyNow: "Buy Now",
        mintNow: "Mint Now",
        rule: "Rule",
        comingSoon: "Coming Soon!",
        type: "Type",
        from: "From",
        to: "To",
        me: "Me",
        rented: "Rented",
        sold: "Sold",
        tabGetLicense: "GET License",
        tabMyLicense: "My License",
        tabMarket: "Market",
        marketDisabled: 'Secondary market is not available yet.',
        bought: "Bought",
        boughtProducts: "Bought products",
        investedProducts: "Invested products",
        issuedProducts: "Issued products",
        positions: "Positions",
        options: "Options",
        all: "All",
        volume: "Volume",
        newest: "Newest",
        price: "Price",
        pending: "Pending",
        audit: "Audit",
        loading: "Loading",
        home: "Home",
        market: "Market",
        markets: "Markets",
        portfolio: "Portfolio",
        license: "License",
        myPositions: "My Positions",
        challengeCredit: "Challenge credit",
        challengeStatus: "Challenge status",
        succeed: "Succeed",
        wait: "Wait",
        return: "Return",
        waitChallenge: "Event is waiting for challenge.",
        waitingGovernanceResult: "Event is waiting for governance mechanism results.",
        eventFinished: "Event is Finished.",
        cancelled: "Cancelled",
        predictionProduct: "Prediction product",
        complaintCountdown: "Complaint Countdown",
        setResult: "Set result",
        challenge: "Challenge",
        recycleTicket: "Recycle ticket",
        eventCancelled: "Event has been cancelled.",
        auditChecking: "Audit Checking",
        insufficientFunds: "Insufficient Funds",
        buy: "Buy",
        listYourToken: "List your token",
        setResultModalTitle: "Set Result:",
        cancelModalTitle: "Cancel",
        cancelIrreversible: "Cancellation is irreversible.",
        challengeModalTitle: "Challenge",
        challengeStakeIntro: "if there is deviation in fact, will be returned to you.",
        challengeStakeButton: "PRDS to Challenge",
        history: "History",
        // ---- v1.9.7 i18n 补漏：组件引用但语言包缺失的 key（纯追加）----
        onRent: "On Rent",
        onSale: "On Sale",
        licenseOwner: "License Owner",
        tokenId: "Token ID",
        getYourLicense: "Get Your License",
        issueTimesList: "Issue Times List",
        expiringDate: "Expiring Date",
        total: "Total",
        time: "Time",
        user: "User",
        days: "Days",
        period: "Period",
        transactionHistory: "Transaction History",
        details: "Details",
        payoff: "Payoff",
        payoffDetails: "Payoff is credited to your balance once the markets issued under this license are settled.",
        rules: "Rules",
        sellRule1: "Set a price and list the license; it stays usable until it is sold.",
        sellRule2: "The owner can cancel the listing at any time before it is sold.",
        rentRule1: "The renter can issue prediction markets with this license during the rental period.",
        rentRule2: "The owner can cancel the listing at any time before it is rented.",
        rentRule3: "Rent is settled in the payment token and paid to the owner upfront.",
        sale: "Sale",
        selling: "Selling",
        unsold: "Unsold",
        licenseSaleRentable: "This license can be sold or rented.",
        licenseCanSell: "This license can be sold.",
        licenseUnsold: "This license is unsold.",
        rentDate: "Rent Date",
        minimumDays: "Minimum days",
        prediLicense: "Predi License",
        confirmCancel: "Confirm cancel {type}?",
        pleaseInputValidPrice: "Please input a valid price",
        pleaseInputValidRentDate: "Please input a valid rent date",
        pleaseInputValidTimes: "Please input valid times",
        rentDateLessThanMinimum: "Rent date must be greater than the minimum days",
        seeMore: "See More"
    },

    claim: {
        title: "Claim PRDs For Free",
        subtitle: "Get your PRDs tokens with just one click",
        walletAddress: "Wallet Address",
        status: "Status",
        connectWalletFirst: "Please Connect Wallet First",
        eligibility: {
            claimed: "You have claimed already",
            eligible: "You are eligible to claim",
            error: "Error checking eligibility"
        },
        button: {
            claim: "Claim",
            alreadyClaimed: "Already Claimed",
            connect: "Connect"
        },
        footerNotice: "Each wallet can claim only once. Make sure you're connected to the correct network.",
        messages: {
            connectFirst: "Please connect your wallet first",
            claimSuccess: "Claim successful!",
            claimFailed: "Claim failed, please try again later",
            txCancelled: "Transaction Cancelled",
            onlyOnce: "Each user can only claim once",
            insufficientBalance: "Insufficient balance in contract, please try again later"
        }
    }
}


